import { Minus, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";

const MIN_SERVINGS = 0;
const MAX_SERVINGS = 10;

export const ServingStepper = ({ id, label, value, onChange }) => {
  const amount = Number.isFinite(value) ? value : 1;

  return (
    <div className="supplement-serving-stepper" data-testid={`supplement-serving-stepper-${id}`}>
      <Button
        type="button"
        variant="outline"
        size="icon"
        disabled={amount <= MIN_SERVINGS}
        onClick={() => onChange(Math.max(MIN_SERVINGS, amount - 1))}
        aria-label={`Decrease ${label}`}
        data-testid={`supplement-serving-decrease-${id}`}
      >
        <Minus aria-hidden="true" />
      </Button>
      <output aria-live="polite" data-testid={`supplement-serving-value-${id}`}>{amount}</output>
      <Button
        type="button"
        variant="outline"
        size="icon"
        disabled={amount >= MAX_SERVINGS}
        onClick={() => onChange(Math.min(MAX_SERVINGS, amount + 1))}
        aria-label={`Increase ${label}`}
        data-testid={`supplement-serving-increase-${id}`}
      >
        <Plus aria-hidden="true" />
      </Button>
    </div>
  );
};